import { render, staticRenderFns } from "./LanguageForm.vue?vue&type=template&id=662bd5e0&scoped=true"
import script from "./LanguageForm.vue?vue&type=script&lang=js"
export * from "./LanguageForm.vue?vue&type=script&lang=js"
import style0 from "./LanguageForm.vue?vue&type=style&index=0&id=662bd5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662bd5e0",
  null
  
)

export default component.exports